/* RESPONSIBLE TEAM: team-workflows */
import StepSerializer from '../step';

export default StepSerializer.extend({
  attrs: {
    conversationSla: 'conversation_sla_id',
  },
});
